import React from 'react';
import {Button} from 'reactstrap';
import {SUPER_ADMIN} from '../../helpers/constants';
import {I18n} from '../../I18n/components/attributesList';

const AttributesListButtons = (props) => {
    return (
        props.authority === SUPER_ADMIN || props.isEditable ? (
            <div className='attributes-list__buttons'>
                {
                    props.onDeleteApp ? <Button color="danger" className="ml-1"
                                                     onClick={props.onDeleteApp}>{I18n[props.lang].delete}</Button> :
                        <span></span>
                }
                <Button
                    color="secondary"
                    className="ml-1"
                    onClick={props.closeModal ? props.closeModal : props.onResetChanges}
                >
                    {I18n[props.lang].cancel}
                </Button>
                <Button color="primary" type="button"
                        onClick={props.onSaveAttributes}
                        disabled={props.editDisable}
                >{I18n[props.lang].save}
                </Button>
            </div>
        ) : (<span></span>)
    )
};

export default AttributesListButtons;





// WEBPACK FOOTER //
// ./src/components/AttributesList/AttributesListButtons.js